import BasicDialog from 'scenes/Dialog/components/BasicDialog/index';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog/index';

import { ENDPOINT } from 'constants/endpoints';
import { Role } from 'helpers/user';

export class FirmActions {
  constructor(api, user) {
    this.api = api;
    this.user = user;
  }

  checkRatingUpdate = () => Role.isCandidate(this.user, true);

  setRating = ({ id, mark }) => {
    return new Promise(resolve => {
      this.api.post(
        ENDPOINT.ACTION.FIRM.POST_RATING,
        {
          id,
          mark,
        },
        {
          handleError: response => {
            ResponseErrorDialog({ response });
            resolve(null);
          },
          handleSuccess: data => {
            BasicDialog({ bodyRender: 'Thank you for your response' });
            resolve(data);
          },
        }
      );
    });
  };
}
